/* lystia-cart-lines.js - інтеракції рядка кошика (T-E5-02, parity/cart.md §2.2).
   Підключення: snippets/cart-line.liquid (defer; ідемпотентно - файл може вантажитись з кожного рядка).
   Залежить від lystia-core.js, lystia-cart.js, lystia-toast.js; події/хуки рядка - з lystia-cart-drawer.js (T-E5-01):
   - swipe (лише touch/pen; ігнор button/input/lystia-qty/.qty): W=96, lock |dx|>8 і |dx|>|dy|, скасування |dy|>10 і |dy|>|dx|,
     dx in [-1.6W, 0]; відпускання: dx<-0.8W видалити (translateX(-110%)), dx<-0.35W відкрити (-96px), інакше закрити;
     тап по відкритому рядку закриває (capture click);
   - видалення: слухає 'lystia:cart-line-remove' (cancelable) -> preventDefault, is-leaving, через 260 мс (0 при reduced-motion)
     LystiaCart.remove(key) і тост «Товар видалено» 5000 мс + «Повернути» (LystiaCart.add з тим самим variant id і qty).
   Тексти тоста - з data-removed-text / data-undo-text на рядку (locales cart.line.removed / cart.line.undo). */
(function () {
  'use strict';
  if (document.lystiaCartLines) return;
  var cartApi = window.LystiaCart;
  if (!cartApi) { console.error('[lystia-cart-lines] потрібен lystia-cart.js'); return; }

  var W = 96;
  var LEAVE_MS = 260;
  var TOAST_MS = 5000;
  var SEL_ROW = '.ov-name--cart .cp-line';
  var SEL_IGNORE = 'button, input, lystia-qty, .qty';

  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function inner(row) { return row.querySelector('.cp-line__in'); }

  /* ---------- видалення з «Повернути» ---------- */
  function resetRow(row) {
    row.classList.remove('is-leaving', 'is-open', 'is-swiping');
    var el = inner(row);
    if (el) el.style.transform = '';
  }

  function toast(row, d) {
    var api = document.lystiaToast;
    if (!api) return;
    api.show(row.getAttribute('data-removed-text') || '', {
      icon: 'check',
      duration: TOAST_MS,
      action: {
        label: row.getAttribute('data-undo-text') || '',
        onClick: function () { cartApi.add({ id: Number(d.variantId), quantity: d.qty }).catch(function () { /* cart:error вже випущено */ }); }
      }
    });
  }

  document.addEventListener('lystia:cart-line-remove', function (e) {
    var row = e.target && e.target.closest && e.target.closest(SEL_ROW);
    if (!row) return;
    e.preventDefault();
    if (row.classList.contains('is-leaving')) return;
    var d = e.detail || {};
    row.classList.add('is-leaving');
    setTimeout(function () {
      cartApi.remove(d.key).then(function () { toast(row, d); }, function () { resetRow(row); });
    }, reduced() ? 0 : LEAVE_MS);
  });

  /* ---------- swipe ---------- */
  var st = null; /* { row, el, x0, y0, dx, locked, pid } */

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var el = e.target.closest && e.target.closest('.ov-name--cart .cp-line__in');
    if (!el || e.target.closest(SEL_IGNORE)) return;
    var row = el.closest('.cp-line');
    if (!row || row.classList.contains('is-leaving')) return;
    st = { row: row, el: el, x0: e.clientX, y0: e.clientY, dx: 0, locked: false, pid: e.pointerId };
  });

  document.addEventListener('pointermove', function (e) {
    if (!st || e.pointerId !== st.pid) return;
    var mx = e.clientX - st.x0;
    var my = e.clientY - st.y0;
    if (!st.locked) {
      if (Math.abs(my) > 10 && Math.abs(my) > Math.abs(mx)) { st = null; return; }
      if (Math.abs(mx) > 8 && Math.abs(mx) > Math.abs(my)) {
        st.locked = true;
        st.row.classList.add('is-swiping');
        try { st.el.setPointerCapture(st.pid); } catch (er) { /* ignore */ }
      } else return;
    }
    st.dx = Math.max(-W * 1.6, Math.min(0, mx));
    st.el.style.transform = 'translateX(' + st.dx + 'px)';
  });

  function end(e) {
    if (!st || (e && e.pointerId !== st.pid)) return;
    var s = st;
    st = null;
    if (!s.locked) return; /* тап без жесту: стан не чіпаємо - відкритий рядок закриє capture-click нижче */
    s.row.classList.remove('is-swiping');
    if (s.dx < -W * 0.8) {
      s.el.style.transform = 'translateX(-110%)';
      var ev = new CustomEvent('lystia:cart-line-remove', {
        bubbles: true, cancelable: true,
        detail: { key: s.row.getAttribute('data-line-key'), variantId: s.row.getAttribute('data-variant-id'), qty: Number(s.row.getAttribute('data-qty')) || 1, row: s.row }
      });
      s.row.dispatchEvent(ev);
    } else if (s.dx < -W * 0.35) {
      s.el.style.transform = 'translateX(' + -W + 'px)';
      s.row.classList.add('is-open');
    } else {
      s.el.style.transform = '';
      s.row.classList.remove('is-open');
    }
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);

  /* тап по зсунутому рядку закриває кнопку (capture) */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('.ov-name--cart .cp-line__in');
    if (!el) return;
    var row = el.closest('.cp-line');
    if (row && row.classList.contains('is-open')) {
      e.preventDefault();
      e.stopPropagation();
      row.classList.remove('is-open');
      el.style.transform = '';
    }
  }, true);

  document.lystiaCartLines = Object.freeze({ reset: resetRow });
})();
